import { render, staticRenderFns } from "./RepliersFilter.vue?vue&type=template&id=6fa0f8ac&scoped=true&"
import script from "./RepliersFilter.vue?vue&type=script&lang=js&"
export * from "./RepliersFilter.vue?vue&type=script&lang=js&"
import style0 from "./RepliersFilter.vue?vue&type=style&index=0&id=6fa0f8ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa0f8ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib'
installComponents(component, {VChip})
